import { Component } from '@angular/core';
import { StandardClientsViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/clients-view/clients-view-wrapper.component';

@Component({
  selector: 'app-customer-view-mobile',
  templateUrl: './clients-view-mobile.component.html',
  styleUrls: ['./clients-view-mobile.component.scss'],
})
export class StandardClientsViewMobileComponent extends StandardClientsViewWrapperComponent {
}
